const locale = {
  COMMAND_CENTRE: 'Command Centre',
  PATIENTS: 'Patients',
  PATIENT_HELP: 'Patient Help',
  REQUESTS: 'Requests',
  ATTENTION: 'Attention',
  CALENDAR: 'Calendar',
  PHARMACIES: 'Pharmacies',
  ORDERS: 'Orders',
  MANAGED_REPEATS: 'Managed Repeats',
  SERVICES: 'Services',
  BANNERS: 'Banners',
  ONLINESHOP: 'Online Shop',
  REVIEWS: 'Reviews',
  SERVICE_DASHBOARD: 'Service Dashboard',
  ANNOUNCEMENTS: "What's New",
  RESOURCES: 'Resources',
  BROADCAST: 'Broadcasting',
  PHARMACY_DETAILS: 'Pharmacy Details',
  BROADCASTING: 'Broadcasting',
  MASTER_SERVICES: 'Master services',
  QUESTIONNAIRES: 'Questionnaires',
  PRODUCTS: 'Products',
  DASHBOARD: 'Advanced Dashboard',
  SMS_CAMPAIGNS: 'SMS campaigns',
  SUPER_LINKS: 'Super links',
  CAMPAIGNS: 'Campaigns',
  MARKETING_MATERIAL: 'Marketing Material',
  MTI_UPLOADER: 'Patient Invites',
  TRAINING_AND_GUIDES: 'Training and Guides',
  IN_APP_BANNERS: 'In-App Banners',
  USERS: 'Users',
  WEBSITE: 'Web Builder',
};

export default locale;
